import { render, staticRenderFns } from "./SelectionBlock.vue?vue&type=template&id=92956c1c&scoped=true&"
import script from "./SelectionBlock.vue?vue&type=script&lang=js&"
export * from "./SelectionBlock.vue?vue&type=script&lang=js&"
import style0 from "./SelectionBlock.vue?vue&type=style&index=0&id=92956c1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92956c1c",
  null
  
)

export default component.exports